module.exports = __webpack_public_path__ + "img/fire.371bc05d.svg";